import { Component, OnInit } from '@angular/core';

import { CacheService } from '../../global/ng2-cache/services/cache.service';
import { AdminService } from '../../services/admin.service';
import { SessionService } from '../../services/session2.service';

@Component({
  selector: 'app-admin-utilities',
  templateUrl: './admin-utilities.component.html'
})
export class AdminUtilitiesComponent implements OnInit {

  loadingPage: boolean = true;
  pages: any[] = [
    {
      page: 'domainMap',
      header: 'Domain Map'
    }
  ];

  currentPage = this.pages[0]

  domainMap: string = '';

  constructor(private cacheService: CacheService,
              private sessionService: SessionService,
              private adminService: AdminService) { }

  ngOnInit() {
    if (!this.cacheService.get('session')) {
      this.sessionService.getSession(true).subscribe(
        (session: any) => {
          this.initView();
        }
      )
    }
    else {
      this.initView();
    }
  }

  private loadDomains() {
    this.loadingPage = true;
    this.domainMap = '';
    this.adminService.getAllDomains().subscribe(
      (result: any) => {
        result.forEach((r) => {
          this.domainMap += `${r.domain},${r.mapTo}\n`;
        });

        this.loadingPage = false;
      },
      error => {

      }
    )
  }
  private initView() {
    this.loadDomains();
  }



}



// WEBPACK FOOTER //
// ./client/app/admin/admin-utilities/admin-utilities.component.ts